<template>
    <AffiliateLandingPage imageExt="png" imageName="BenefitHub" welcomeGroup="BenefitHub members" routePath="benefithub">
    </AffiliateLandingPage>
</template>
  
<script>
import AffiliateLandingPage from '@/components/Affiliate/AffiliateLandingPage.vue'

export default {
    components: {
        AffiliateLandingPage
    },
    name: 'BenefitHubLandingPage'
}
</script>
  
<style></style>
  